import { get, writable } from 'svelte/store';
import { user } from '../../app.store';
import { ActivityTypesService } from '../../services/activity-types.service';
export const loading = writable(false);
export const editing = writable(false);
export const filter = writable(null);
export const pagination = writable(null);
export const records = writable([]);
export const record = writable(null);
export const selectedActivityCategory = writable(0);
export const selectedDossierType = writable(0);
export const applyUserRevenue = writable(false);
export const dossierActivities = writable(false);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        filter.set({ criteria: {}, params: null, sorting: "" });
        pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
        records.set([]);
        record.set(null);
        selectedActivityCategory.set(0);
        selectedDossierType.set(0);
    }
    loadSettings();
    await loadActivityTypes();
}
export async function loadActivityTypes() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        _filter.criteria.activityCategoryId = get(selectedActivityCategory);
        _filter.criteria.dossierTypeId = get(selectedDossierType);
        let _resp = await ActivityTypesService.getActivityTypes(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
function loadSettings() {
    let theUser = get(user);
    let _applyUserRevenue = theUser != null ? theUser.regionSettings.applyUserRevenue : false;
    applyUserRevenue.set(_applyUserRevenue === 1);
    let _dossierActivities = theUser != null ? theUser.regionSettings.dossierActivities : false;
    dossierActivities.set(_dossierActivities === 1);
}
export function onCreate() {
    // console.log("onCreate");
    let item = {
        oid: 0,
        numCode: 0,
        description: '',
        hourlyRevenue: 0,
        activityCategoryId: get(selectedActivityCategory),
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    record.set(Object.assign({}, item.activityType));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    let _dossierTypeId = get(selectedDossierType);
    // set value according to combo
    _record.dossierTypeId = _dossierTypeId == 0 ? null : _dossierTypeId;
    await ActivityTypesService.saveActivityType(_record);
    await loadActivityTypes();
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ActivityTypesService.deleteActivityType(item.oid);
    await loadActivityTypes();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    loadActivityTypes();
}
